import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67535b66")

_pushScopeId("data-v-67535b66")
const _hoisted_1 = { class: "main mypage" }
const _hoisted_2 = { class: "my-page__top" }
const _hoisted_3 = { class: "top__section" }
const _hoisted_4 = { class: "my-page__context" }
const _hoisted_5 = { class: "my-page__thumbnails" }
const _hoisted_6 = {
  key: 0,
  class: "my-page__thumbnail"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("li", { class: "my-page__thumbnail--title" }, [
  /*#__PURE__*/_createVNode("span", { class: "label" }, " "),
  /*#__PURE__*/_createVNode("span", { class: "label" }, "온라인 대면진료"),
  /*#__PURE__*/_createVNode("span", { class: "label" }, "2차 소견")
], -1)
const _hoisted_8 = { class: "my-page__thumbnail--history" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "label" }, "신청내역", -1)
const _hoisted_10 = { class: "value -bold" }
const _hoisted_11 = { class: "value -bold" }
const _hoisted_12 = { class: "my-page__thumbnail--complete" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "label" }, "회신완료", -1)
const _hoisted_14 = { class: "value -bold" }
const _hoisted_15 = { class: "value -bold" }
const _hoisted_16 = {
  key: 1,
  class: "my-page__thumbnail"
}
const _hoisted_17 = { class: "my-page__thumbnail--mydoctor" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "label" }, "관심의사", -1)
const _hoisted_19 = { class: "value -bold" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "value -bold" }, " ", -1)
const _hoisted_21 = { class: "my-page__nav -regular" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("개인정보수정")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("패스워드 변경")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("관심의사")
const _hoisted_25 = { class: "main__section my-page" }
const _hoisted_26 = { class: "my-page__context" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")
  const _directive_Account = _resolveDirective("Account")

  return _withDirectives((_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_5, [
              (_ctx.summary.isLoading)
                ? (_openBlock(), _createBlock("ul", _hoisted_6, [
                    _hoisted_7,
                    _createVNode("li", _hoisted_8, [
                      _hoisted_9,
                      _createVNode("span", _hoisted_10, _toDisplayString(_ctx.ServiceCount.onlineCare.request), 1),
                      _createVNode("span", _hoisted_11, _toDisplayString(_ctx.ServiceCount.secondOpinion.request), 1)
                    ]),
                    _createVNode("li", _hoisted_12, [
                      _hoisted_13,
                      _createVNode("span", _hoisted_14, _toDisplayString(_ctx.ServiceCount.onlineCare.response), 1),
                      _createVNode("span", _hoisted_15, _toDisplayString(_ctx.ServiceCount.secondOpinion.response), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.summary.isLoading)
                ? (_openBlock(), _createBlock("ul", _hoisted_16, [
                    _createVNode("li", _hoisted_17, [
                      _hoisted_18,
                      _createVNode("span", _hoisted_19, _toDisplayString(_ctx.DoctorCount), 1),
                      _hoisted_20
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("nav", _hoisted_21, [
            _createVNode("div", null, [
              _createVNode(_component_router_link, {
                class: "my-page--link",
                to: _ctx.path.Profile
              }, {
                default: _withId(() => [
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                class: "my-page--link",
                to: _ctx.path.Password
              }, {
                default: _withId(() => [
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                class: "my-page--link",
                to: _ctx.path.MyDoctor
              }, {
                default: _withId(() => [
                  _hoisted_24
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_25, [
      _createVNode("div", _hoisted_26, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 512)), [
    [_directive_Account]
  ])
})